module.exports = __webpack_public_path__ + "img/magalu-carreiras.28746f80.png";